// extracted by mini-css-extract-plugin
module.exports = {"mapTileIconWrapper":"map-tile-icon_mapTileIconWrapper__cV4fY"};